import React from "react";
import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";
import { useApp } from "../context/AppContext";

const PaymentCancel = () => {
  const { t } = useApp();
  return (
    <div className="max-w-lg mx-auto px-4 py-24 text-center fade-up">
      <XCircle className="h-12 w-12 mx-auto mb-6 text-[#8b1e3f]" strokeWidth={1.5} />
      <h1 className="font-serif-lux text-3xl mb-3">Paiement annulé</h1>
      <p className="text-sm text-[#555] mb-6">Votre panier est conservé. Vous pouvez reprendre votre commande quand vous le souhaitez.</p>
      <div className="flex gap-3 justify-center">
        <Link to="/cart" className="bg-[#1b1b1b] text-white px-6 py-3 text-sm tracking-wide hover:bg-[#b08d57] transition-colors">{t("cartTitle")}</Link>
        <Link to="/c/all" className="border border-[#1b1b1b] px-6 py-3 text-sm tracking-wide hover:bg-[#1b1b1b] hover:text-white transition-colors">{t("continueShopping")}</Link>
      </div>
    </div>
  );
};

export default PaymentCancel;
